import React, { useState } from "react";
import { Key } from "@phosphor-icons/react";
import api from "@/lib/api";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";

export default function ChangePasswordDialog({ className = "" }) {
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ current_password: "", new_password: "", repeat: "" });
  const [status, setStatus] = useState(null);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (form.new_password.length < 10) { setStatus({ ok: false, msg: "Mindestens 10 Zeichen." }); return; }
    if (form.new_password !== form.repeat) { setStatus({ ok: false, msg: "Passwörter stimmen nicht überein." }); return; }
    setBusy(true); setStatus(null);
    try {
      await api.post("/auth/change-password", { current_password: form.current_password, new_password: form.new_password });
      setStatus({ ok: true, msg: "Passwort geändert. Andere Sitzungen wurden abgemeldet." });
      setForm({ current_password: "", new_password: "", repeat: "" });
    } catch (err) {
      setStatus({ ok: false, msg: err.response?.data?.detail || "Fehler beim Ändern." });
    } finally { setBusy(false); }
  };

  return (
    <Dialog open={open} onOpenChange={(o) => { setOpen(o); if (!o) setStatus(null); }}>
      <DialogTrigger asChild>
        <button className={`flex items-center gap-1.5 ${className}`} data-testid="change-password-btn" title="Passwort ändern">
          <Key size={14} /> Passwort
        </button>
      </DialogTrigger>
      <DialogContent className="max-w-sm" data-testid="change-password-dialog">
        <DialogHeader><DialogTitle>Passwort ändern</DialogTitle><DialogDescription>Nach dem Ändern werden alle anderen Sitzungen abgemeldet.</DialogDescription></DialogHeader>
        <form onSubmit={submit} className="space-y-3">
          <div><Label>Aktuelles Passwort</Label><Input type="password" autoComplete="current-password" value={form.current_password} onChange={(e) => setForm({ ...form, current_password: e.target.value })} data-testid="cp-current" required /></div>
          <div><Label>Neues Passwort (min. 10 Zeichen)</Label><Input type="password" autoComplete="new-password" value={form.new_password} onChange={(e) => setForm({ ...form, new_password: e.target.value })} data-testid="cp-new" required /></div>
          <div><Label>Neues Passwort wiederholen</Label><Input type="password" autoComplete="new-password" value={form.repeat} onChange={(e) => setForm({ ...form, repeat: e.target.value })} data-testid="cp-repeat" required /></div>
          {status && <p className={`text-xs ${status.ok ? "text-emerald-700" : "text-rose-600"}`} data-testid="cp-status">{status.msg}</p>}
          <Button type="submit" disabled={busy} className="w-full" data-testid="cp-submit">{busy ? "Speichern…" : "Passwort ändern"}</Button>
        </form>
      </DialogContent>
    </Dialog>
  );
}
